export default __webpack_public_path__ + "static/media/button.16289653.png";